import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import { Container } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { Doughnut, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Chart, ArcElement } from 'chart.js';
import { clearErrors, getAllProducts } from '../../redux/actions/productAction';
import { getAllUsers } from '../../redux/actions/userAction';
import { getAllOrders } from '../../redux/actions/orderActions';
Chart.register(ArcElement);

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const Dashboard = () => {
    const dispatch = useDispatch();
    const { products, error } = useSelector((state) => state.products);
    const { orders } = useSelector((state) => state.allOrders);
    const { users } = useSelector((state) => state.allUsers);

    const getTotalAmount = () => {
        let totalAmount = 0;
        if (orders) {
            totalAmount = orders.reduce((acc, item) => acc + item.totalPrice, 0);
        }
        return totalAmount.toFixed(2);
    };

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        dispatch(getAllProducts());
        dispatch(getAllUsers());
        dispatch(getAllOrders());
    }, [error]);

    let outOfStock = 0;

    products &&
        products.forEach((item) => {
            if (item.Stock === 0) {
                outOfStock += 1;
            }
        });

    const lineState = {
        labels: ['Initial Amount', 'Earn Amount'],
        datasets: [
            {
                label: 'TOTAL AMOUNT',
                backgroundColor: ['#6200ea'],
                hoverBackgroundColor: ['rgba(197, 72, 49)'],
                data: [0, getTotalAmount()],
            },
        ],
    };
    const doughnutState = {
        labels: ['Out of Stock', 'In Stock'],
        datasets: [
            {
                backgroundColor: ['#b799ff', '#6200ea'],
                hoverBackgroundColor: ['#b799ff', '#6200ea'],
                data: [outOfStock, [products.length - outOfStock]],
            },
        ],
    };

    return (
        <Container>
            <div className='section-padding-top section-padding-bottom'>
                <Row>
                    <Col md={3}>
                        <Sidebar />
                    </Col>
                    <Col md={9}>
                        <div className='dashboardContainer'>
                            <SectionHeading heading={'Dashboard'} />
                            <div className='dashboardSummary'>
                                <div className='priceBg'>
                                    <p>
                                        Total Amount <br /> ₹{getTotalAmount()}
                                    </p>
                                </div>
                                <div className='dashboardCircles'>
                                    <Link to='/admin/products'>
                                        <p>
                                            Products <br /> {products && products.length}
                                        </p>
                                    </Link>
                                    <Link to='/admin/orders'>
                                        <p>
                                            Orders <br /> {orders && orders.length}
                                        </p>
                                    </Link>
                                    <Link to='/admin/users'>
                                        <p>
                                            Users <br /> {users && users.length}
                                        </p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className='lineChart mt-5'>
                            <Line data={lineState} />
                        </div>
                        <div className='doughnutChart'>
                            <Doughnut data={doughnutState} />
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    );
};

export default Dashboard;
